import { useTranslation } from '../../../hooks/use-translations';
import React from 'react';
import { Trans } from 'react-i18next';
import { Link } from '../link/Link';

export type EnrichedTextProps = {
  textKey: string;
};

export const EnrichedText = ({ textKey }: EnrichedTextProps) => {
  const { t } = useTranslation();

  const links = {
    myaccount: <Link href={'/account/overview'} textKey={'common.my-account'} />,
    shipping: <Link href={'/info/about/shippingcosts'} textKey={'common.shipping-and-delivery'} />,
    personal: <Link href={'/account/customer/overview'} textKey={'common.personal-information'} />,
    terms: <Link href={'/legal/terms'} textKey={'common.here'} />,
    customercare: <Link href={'/contact_us'} textKey={'common.cc-team'} />,
  };

  return <Trans i18nKey={textKey} components={links} t={t} />;
};
